import { Injectable  } from '@angular/core';

@Injectable ()
export class MethodOfPaymentService {
  payment: number;

  setPayment(value) {
    this.payment = value;
  }
  getPayment() {
    return this.payment;
  }

}
